import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { COPY } from '../presentationCopy';
import { PRES, TYPE } from '../chrome';
import { LibrarySlideUpdate } from '../types';
import { libraryUpdateDetail, libraryUpdateHeading } from '../librarySlides';

interface LibraryUpdatesDialogProps {
  updates: LibrarySlideUpdate[];
  onClose: () => void;
  onOpen: (slideId: string) => void;
}

const LibraryUpdatesDialog: React.FC<LibraryUpdatesDialogProps> = ({ updates, onClose, onOpen }) => (
  <Dialog open={updates.length > 0} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>{COPY.libraryUpdateTitle}</DialogTitle>
    <DialogContent>
      <Typography sx={{ mb: 1.5, fontFamily: TYPE.ui, ...TYPE.body, color: PRES.textSecondary }}>
        {COPY.libraryUpdateHelp}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {updates.map((update) => (
          <Button
            key={update.slideId}
            onClick={() => onOpen(update.slideId)}
            sx={{
              display: 'block',
              textAlign: 'left',
              textTransform: 'none',
              py: 1.25,
              px: 1.5,
              border: `1px solid ${PRES.borderSubtle}`,
              bgcolor: PRES.surface,
              color: PRES.textPrimary,
              boxShadow: 'none',
            }}
          >
            <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.title, color: PRES.textPrimary }}>
              {libraryUpdateHeading(update)}
            </Typography>
            <Typography sx={{ mt: 0.25, fontFamily: TYPE.ui, ...TYPE.caption, color: PRES.textSecondary }}>
              {libraryUpdateDetail(update)}
            </Typography>
          </Button>
        ))}
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} sx={{ textTransform: 'none' }}>{COPY.confirm}</Button>
    </DialogActions>
  </Dialog>
);

export default LibraryUpdatesDialog;
